document.addEventListener('DOMContentLoaded', () => {
    gsap.registerPlugin(ScrollTrigger, SplitText);

    const titleElements = document.querySelectorAll('.animated-title');

    titleElements.forEach(text => {
        // Разбиваем текст на строки
        const split = new SplitText(text, {
            type: 'lines',
            linesClass: 'split-line'
        });

        // Оборачиваем каждую строку в div для анимации
        split.lines.forEach(line => {
            const wrapper = document.createElement('div');
            wrapper.classList.add('line-wrapper');
            line.parentNode.insertBefore(wrapper, line);
            wrapper.appendChild(line);
        });

        const tl = gsap.timeline();

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        tl.to(split.lines, {
                            duration: 1.2,
                            y: 0,
                            ease: 'power4.out',
                            stagger: 0.15 // Задержка между строками
                        });

                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.4,
            }
        );

        observer.observe(text);
    });
});
